import React from "react";
import { Box, TouchableBox } from "./AHTheme/Box";
import { AHText } from "./Text";
import { View } from "react-native";
import { AHIcon, AHIconType } from "./AHIcon";

export function AHEmptyScreen(props: {
  title: React.ReactNode;
  subtitle: React.ReactNode;
  illustration?: React.ReactNode;
  cta?: React.ReactNode;
  helpLinks?: React.ReactNode;
  highlight?: React.ReactNode;
}) {
  return (
    <View
      style={{
        alignItems: "center",
        flex: 1,
        justifyContent: "center",
      }}
    >
      <Box
        space="large"
        style={{ flex: 1, maxWidth: 600, justifyContent: "center" }}
      >
        <AHText textAlign="center" type="title-big" spaceBottom="medium">
          {props.title}
        </AHText>
        <Box style={{ alignSelf: "center" }}>
          <AHText color="darkText" type="title-small-regular" selectable>
            {props.subtitle}
          </AHText>
        </Box>
        {props.highlight}
        <Box
          style={{ flex: 1, maxHeight: 350, overflow: "hidden" }}
          spaceVertical="large"
        >
          {props.illustration}
        </Box>
        <Box style={{ alignSelf: "center" }}>{props.cta}</Box>
        {props.helpLinks}
      </Box>
    </View>
  );
}

function Link(props: {
  onPress: () => void;
  text: React.ReactNode;
  icon: AHIconType;
}) {
  return (
    <Box spaceTop="small">
      <TouchableBox
        style={{
          alignSelf: "center",
          flexDirection: "row",
          alignItems: "center",
        }}
        onPress={props.onPress}
        spaceVertical="small"
      >
        <AHText spaceRight="small" type="subtitle" color="primary">
          {props.text}
        </AHText>
        <AHIcon color="primary" type={props.icon} />
      </TouchableBox>
    </Box>
  );
}

AHEmptyScreen.Link = Link;
